import { BREAKPOINTS } from 'app/styles/breakpoints';
import { VariantMappingRules } from 'app/components/common/typography/responsive-typography';

export const typographyRules: VariantMappingRules = {
    [BREAKPOINTS.DESKTOP]: {
        heading: 'title',
    },
    [BREAKPOINTS.MOBILE_LANDSCAPE]: {
        heading: 'subtitle1',
        title: 'subtitle1',
        subtitle1: 'subtitle2',
        subtitle2: 'subtitle3',
        subtitle3: 'body1',
        body1: 'body2',
        body2: 'body3',
    },
};
